













import { Component, Vue, PropSync, Watch } from "vue-property-decorator";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import mapbox, { MapboxOptions, MapMouseEvent, MapTouchEvent, Point } from "mapbox-gl";
import { FeatureCollection, featureCollection, point, feature, Feature } from "@turf/turf";
import { getters, actions } from "@/observables";
import PointPopup from "./TDPointPopup.vue";
import "mapbox-gl/dist/mapbox-gl.css";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import TenderDispath from "./TenderDispath.vue";
@Component({
  components: { PointPopup }
})
export default class STMap extends Vue {
  @PropSync("routePoint", { default: () => [] }) route!: TenderDispath.TenderDispathPoint[];
  private mapref?: mapbox.Map = undefined;
  mapboxHasLoaded = false;
  // Create an empty GeoJSON feature collection for workplace locations
  workplaces = {
    type: "FeatureCollection",
    features: []
  } as GeoJSON.FeatureCollection;
  openPointPopup = false;
  point = {} as TenderDispath.TenderDispathPoint | undefined;

  $refs!: {
    vue: Vue;
    inject: HTMLElement;
  };

  /* Computed */
  get centerPosition(): [number, number] {
    // take the selected warehouse to the center of the position
    return this.warehouseSelected && this.warehouseSelected.vlLongitude
      ? [this.warehouseSelected.vlLongitude, this.warehouseSelected.vlLatitude]
      : [-101.145734, 38.273244];
  }

  get warehouseSelected() {
    return getters.getTDWarehouseSelected();
  }

  /* Watch*/
  @Watch("warehouseSelected") onWarehouseSelected(newValue: TenderMixOperator.Warehouse) {
    if (newValue && newValue.vlLatitude && newValue.vlLongitude) {
      this.flyTo([newValue.vlLongitude, newValue.vlLatitude]);
      this.clearRoute();
      this.updateWarehouse();
      this.openPointPopup = false;
    }
  }

  /* Hooks */
  mounted() {
    mapbox.accessToken =
      "pk.eyJ1Ijoic29saW5mdGVjLWRldiIsImEiOiJjanlnOGFpODAwMGljM2hvYTB0bzQ1eWcwIn0.yjrGDZTcbZs_G2xeKqyh8g";
    const options: MapboxOptions = {
      container: this.$refs.inject,
      // style: "mapbox://styles/solinftec-dev/cjasfb7cpj6qo2rn0u09jl604", // stylesheet location
      style: "mapbox://styles/mapbox/satellite-streets-v10", // stylesheet location
      center: this.centerPosition, // starting position [lng, lat]
      zoom: 10 // starting zoom
    };
    this.mapref = new mapbox.Map(options);
    this.mapref.on("load", this.onLoad);
    this.mapref.on("click", this.onClick);
    this.mapref.getCanvas().style.cursor = "crosshair"; // set the crosshair in the style of the map cursor

    this.mapref.addControl(
      new MapboxGeocoder({
        accessToken: mapbox.accessToken,
        mapboxgl: mapbox,
        localGeocoder: this.coordinatesGeocoder,
        placeholder: "Search by address or try: -40, 170"
      })
    );
  }

  /* Methods */
  async onLoad() {
    this.createLayerWarehouse();
    this.createLayerWorkplace();
    this.createLayerRoute();
    this.createLayerArrowsRoute();
    this.createClickEventWorkplaces();
    this.mapref && this.mapref.resize();
    this.mapboxHasLoaded = true;
  }

  createClickEventWorkplaces() {
    if (this.mapref) {
      this.mapref.on(
        "click",
        "workplaces",
        (
          e: mapbox.MapMouseEvent & {
            features?: mapbox.MapboxGeoJSONFeature[] | undefined;
          } & mapbox.EventData
        ) => {
          this.flyTo([e.lngLat.lng, e.lngLat.lat]);

          if (e && e.features && e.features.length) {
            const properties = e.features[0].properties;
            this.openPointPopup = true;
            this.point = this.route.find(point => point.sequence == properties?.sequencia);
          }
        }
      );

      // Change the cursor to a pointer when the mouse is over the workplace layer.
      this.mapref.on("mouseenter", "workplaces", e => {
        this.alternedMouseCursorStyle(e, "workplaces");
      });

      // Change it back to a pointer when it leaves.
      this.mapref.on("mouseleave", "workplaces", e => {
        this.alternedMouseCursorStyle(e, "workplaces");
      });
    }
  }

  flyTo(coords: [number, number]) {
    this.mapref &&
      this.mapref.flyTo({
        center: coords,
        essential: true,
        zoom: 10
      });
  }

  alternedMouseCursorStyle(e: MapMouseEvent, source: string) {
    if (this.mapref) {
      const features = this.mapref.queryRenderedFeatures(e.point, { layers: [source] });
      this.mapref.getCanvas().style.cursor = features.length ? "pointer" : "crosshair";
    }
  }

  createNewWorkplacePoint(coords: [number, number]) {
    // Store the clicked point as a new GeoJSON feature with
    // const pt = point(coords, {
    //   sequencia: `${this.route.length + 1}`
    // });

    this.workplaces.features.push({
      type: "Feature",
      properties: {
        sequencia: `${this.route.length + 1}`
      },
      geometry: {
        type: "Point",
        coordinates: coords
      }
    });
    this.updateWorkplaces(this.workplaces);
  }

  updateWorkplaces(geojson: GeoJSON.FeatureCollection) {
    if (this.mapref) {
      (this.mapref.getSource("workplaces") as mapboxgl.GeoJSONSource).setData(geojson);
      (this.mapref.getSource("workplaces-symbol") as mapboxgl.GeoJSONSource).setData(geojson);
      // this.mapref.getSource("workplaces").setData(geojson);
      // this.mapref.getSource("workplaces-symbol").setData(geojson);
    }
  }

  updateWarehouse() {
    // Create a GeoJSON feature collection for the warehouse
    const warehouseLocation = this.centerPosition;
    // const geojson = featureCollection([point(warehouseLocation)]);
    const geojson = {
      type: "FeatureCollection",
      features: [point(warehouseLocation)]
    } as GeoJSON.FeatureCollection;
    if (this.mapref) {
      (this.mapref.getSource("warehouse") as mapboxgl.GeoJSONSource).setData(geojson);
      (this.mapref.getSource("warehouse-symbol") as mapboxgl.GeoJSONSource).setData(geojson);
      // this.mapref.getSource("warehouse").setData(geojson);
      // this.mapref.getSource("warehouse-symbol").setData(geojson);
    }
  }

  // add a new layer to the map
  addLayer(layer: any) {
    this.mapref && this.mapref.addLayer(layer);
  }

  // Listen for a click on the map
  onClick(e: MapTouchEvent) {
    const features =
      this.mapref && this.mapref.queryRenderedFeatures(e.point, { layers: ["workplaces"] });

    if (features && features.length) {
      return;
    }
    const coords = [e.lngLat.lng, e.lngLat.lat];
    this.addNewPoint(coords);
  }

  addNewPoint(coords: any) {
    this.createNewWorkplacePoint(coords);
    this.point = {
      sequence: this.route.length + 1,
      latitude: coords[1],
      longitude: coords[0],
      notes: ""
    } as TenderDispath.TenderDispathPoint;

    this.addRoutePoint(this.point);
    this.calculateRoute();
    this.openPointPopup = true;
    this.flyTo([coords[0], coords[1]]);
  }

  removeWorkplacePoint(point: TenderDispath.TenderDispathPoint) {
    this.workplaces.features = this.workplaces.features.filter(
      place => place.properties?.sequencia != point.sequence
    );

    this.workplaces.features.forEach((place, index) => {
      if (place && place.properties && place.properties.sequencia) {
        place.properties.sequencia = index + 1;
      }
    });

    this.updateWorkplaces(this.workplaces);
    this.workplaces.features.length ? this.calculateRoute() : this.clearRoute();
    this.flyTo(this.lastPosition());
  }

  lastPosition(): [number, number] {
    const index = this.route.length - 1;
    return index >= 0
      ? [this.route[index].longitude, this.route[index].latitude]
      : this.centerPosition;
  }

  addRoutePoint(point: TenderDispath.TenderDispathPoint) {
    this.route.push(point);
  }

  updateRoutePoint(point: TenderDispath.TenderDispathPoint) {
    console.log("updateRoutePoint", point);
  }

  removeRoutePoint(point: TenderDispath.TenderDispathPoint) {
    this.route.splice(point.sequence - 1, 1);
    this.reorderSequencePoints();
    this.removeWorkplacePoint(point);
  }

  reorderSequencePoints() {
    this.route.forEach((point, index) => {
      point.sequence = index + 1;
    });
  }

  clearRoute() {
    this.route = [];
    this.workplaces = {
      type: "FeatureCollection",
      features: []
    } as GeoJSON.FeatureCollection;
    this.updateWorkplaces(this.workplaces);
    this.updateLayerRoute({
      coordinates: [],
      type: "LineString"
    });
  }

  beforeDestroy() {
    this.destroyMapbox();
  }

  async calculateRoute() {
    // inverte de long-lat para lat-long
    try {
      let routeFromDispath = `${this.centerPosition[1]},${this.centerPosition[0]}&point=`;
      routeFromDispath += this.route.map(i => [i.latitude, i.longitude]).join("&point=");
      const response = await actions.mapGenerateCarRoute(routeFromDispath);
      const route = response && response.paths.length && response.paths[0].points;
      this.updateLayerRoute(route);
    } catch (e) {
      console.error(e);
    }
  }

  updateLayerRoute(route: any) {
    // Create a GeoJSON feature collection
    // const routeGeoJSON = featureCollection([feature(route)]);
    const geojson = {
      type: "FeatureCollection",
      features: [feature(route)]
    } as GeoJSON.FeatureCollection;
    this.mapref && (this.mapref.getSource("route") as mapboxgl.GeoJSONSource).setData(geojson);
    // this.mapref && this.mapref.getSource("route").setData(geojson);
  }

  destroyMapbox() {
    /* Necessário pois estava removendo o mapa antes dos componentes filhos serem destruídos */
    this.$nextTick(() => {
      if (this.mapref) {
        this.mapref.off("load", this.onLoad);
        this.mapref.remove();
        this.mapref = undefined;
        this.mapboxHasLoaded = false;
      }
    });
  }

  // Layers

  createLayerWarehouse() {
    // Create a GeoJSON feature collection for the warehouse
    const warehouseLocation = this.centerPosition;
    const warehouse = featureCollection([point(warehouseLocation)]);
    // // Create a circle layer
    this.addLayer({
      id: "warehouse",
      type: "circle",
      source: {
        data: warehouse,
        type: "geojson"
      },
      paint: {
        "circle-radius": 10,
        "circle-color": "white",
        "circle-stroke-color": "#3887be",
        "circle-stroke-width": 3
      }
    });

    // Create a symbol layer on top of circle layer
    this.addLayer({
      id: "warehouse-symbol",
      type: "symbol",
      source: {
        data: warehouse,
        type: "geojson"
      },
      layout: {
        "icon-image": "town-hall-15",
        "icon-size": 1
      },
      paint: {
        "text-color": "#3887be"
      }
    });
  }

  createLayerWorkplace() {
    this.addLayer({
      id: "workplaces",
      type: "circle",
      source: {
        data: this.workplaces,
        type: "geojson"
      },
      // layout: {
      //   "icon-allow-overlap": true,
      //   "icon-ignore-placement": true,
      //   "icon-image": "marker-15"
      // }
      paint: {
        "circle-radius": 9,
        "circle-color": "white",
        "circle-stroke-color": "#3887be",
        "circle-stroke-width": 3
      }
    });

    // Create a symbol layer on top of circle layer
    this.addLayer({
      id: "workplaces-symbol",
      type: "symbol",
      source: {
        data: this.workplaces,
        type: "geojson"
      },
      layout: {
        // "text-field": "1",
        "text-field": ["get", "sequencia"]
      },
      paint: {
        "text-color": "#3887be"
      }
    });
  }

  createLayerRoute() {
    if (this.mapref) {
      this.mapref.addSource("route", {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: []
        } as GeoJSON.FeatureCollection
      });

      this.mapref.addLayer(
        {
          id: "routeline-active",
          type: "line",
          source: "route",
          layout: {
            "line-join": "round",
            "line-cap": "round"
          },
          paint: {
            "line-color": "#3887be",
            "line-width": ["interpolate", ["linear"], ["zoom"], 12, 3, 22, 12]
          }
        },
        "waterway-label"
      );
    }
  }

  createLayerArrowsRoute() {
    this.mapref &&
      this.mapref.addLayer(
        {
          id: "routearrows",
          type: "symbol",
          source: "route",
          layout: {
            "symbol-placement": "line",
            "text-field": "▶",
            "text-size": ["interpolate", ["linear"], ["zoom"], 12, 24, 22, 60],
            "symbol-spacing": ["interpolate", ["linear"], ["zoom"], 12, 30, 22, 160],
            "text-keep-upright": false
          },
          paint: {
            "text-color": "#3887be",
            "text-halo-color": "hsl(55, 11%, 96%)",
            "text-halo-width": 3
          }
        },
        "waterway-label"
      );
  }
  /* given a query in the form "lng, lat" or "lat, lng" returns the matching
   * geographic coordinate(s) as search results in carmen geojson format,
   * https://github.com/mapbox/carmen/blob/master/carmen-geojson.md
   */
  coordinatesGeocoder = function(query: any) {
    // match anything which looks like a decimal degrees coordinate pair
    const matches = query.match(/^[ ]*(?:Lat: )?(-?\d+\.?\d*)[, ]+(?:Lng: )?(-?\d+\.?\d*)[ ]*$/i);
    if (!matches) {
      return null;
    }

    function coordinateFeature(lng: any, lat: any) {
      return {
        center: [lng, lat],
        geometry: {
          type: "Point",
          coordinates: [lng, lat]
        },
        // eslint-disable-next-line @typescript-eslint/camelcase
        place_name: `Lat: ${lat} Lng: ${lng}`,
        // eslint-disable-next-line @typescript-eslint/camelcase
        place_type: ["coordinate"],
        properties: {},
        type: "Feature"
      };
    }

    const coord1 = Number(matches[1]);
    const coord2 = Number(matches[2]);
    const geocodes = [];

    if (coord1 < -90 || coord1 > 90) {
      // must be lng, lat
      geocodes.push(coordinateFeature(coord1, coord2));
    }

    if (coord2 < -90 || coord2 > 90) {
      // must be lat, lng
      geocodes.push(coordinateFeature(coord2, coord1));
    }

    if (geocodes.length === 0) {
      // else could be either lng, lat or lat, lng
      geocodes.push(coordinateFeature(coord1, coord2));
      geocodes.push(coordinateFeature(coord2, coord1));
    }

    return geocodes;
  };
}
